export const BASE_URL = (import.meta.env.VITE_API_ENDPOINT as string)
  ? import.meta.env.VITE_API_ENDPOINT
  : "https://webchat.dev.amitysolutions.com";
